import { WebMercatorViewport } from "@deck.gl/core";
import { create } from "zustand";

const useMapState = create((set, get) => ({
  layers: [],
  downloadDialogVisible: false,
  resourceInfoId: null,
  containerRect: null,

  setDownloadDialogVisible: (visible) =>
    set({ downloadDialogVisible: visible }),

  setResourceInfoId: (resourceInfoId) => set({ resourceInfoId }),

  setContainerRect: (containerRect) => set({ containerRect }),

  setLayers: (layers) => set({ layers: sortLayers(layers) }),

  addOrUpdateLayers: (layers) => {
    for (let layer of layers) {
      get().removeLayer(layer.props.id);
    }
    set({ layers: sortLayers([...get().layers, ...layers]) });
  },

  viewState: {
    longitude: -3.7036,
    latitude: 38.4167,
    zoom: 5,
    maxZoom: 16,
    pitch: 0,
    bearing: 0,
  },
  mapStyle:
    "https://basemaps.cartocdn.com/gl/dark-matter-nolabels-gl-style/style.json",

  setViewState: (newViewState) => set({ viewState: newViewState }),

  removeLayers: (optionId) => {
    let newLayers = get().layers.filter(
      (l) => l.props.userData.option.id !== optionId
    );
    set({ layers: sortLayers(newLayers) });
  },

  removeLayer: (layerId) => {
    let newLayers = get().layers.filter((l) => l.props.id !== layerId);
    set({ layers: sortLayers(newLayers) });
  },

  removeAllLayers: (type) => {
    let newLayers = get().layers.filter((l) => l.props.id.indexOf(type) == -1);
    set({ layers: sortLayers(newLayers) });
  },

  fitBounds: (bounds, forceFit = false) => {
    const { viewN, viewS, viewE, viewW } = bounds;
    const targetWestSouth = [viewW, viewS];
    const targetEastNorth = [viewE, viewN];
    const { width, height } = get().containerRect;

    // Construir viewport actual
    const currentView = get().viewState;
    const currentViewport = new WebMercatorViewport({
      width,
      height,
      longitude: currentView.longitude,
      latitude: currentView.latitude,
      zoom: currentView.zoom,
      pitch: currentView.pitch || 0,
      bearing: currentView.bearing || 0,
    });

    // Obtener límites actuales del viewport
    const currentWestSouth = currentViewport.unproject([0, height]);
    const currentEastNorth = currentViewport.unproject([width, 0]);

    // Si los bounds objetivo ya están visibles, no se hace el centrado
    if (
      !forceFit &&
      targetWestSouth[0] >= currentWestSouth[0] &&
      targetWestSouth[1] >= currentWestSouth[1] &&
      targetEastNorth[0] <= currentEastNorth[0] &&
      targetEastNorth[1] <= currentEastNorth[1]
    ) {
      return;
    }

    // Si no, calcular y centrar los bounds
    const { longitude, latitude, zoom } = new WebMercatorViewport({
      width,
      height,
    }).fitBounds([targetWestSouth, targetEastNorth]);

    set((state) => ({
      viewState: { ...state.viewState, longitude, latitude, zoom: zoom - 1 },
    }));
  },
}));

const sortLayers = (layers) => {
  return layers.sort(
    (a, b) => a.props.userData.zIndex - b.props.userData.zIndex
  );
};

export default useMapState;
